import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

interface HomeButtonControlProps {
  center: L.LatLngExpression;
}

const HomeButtonControl: React.FC<HomeButtonControlProps> = ({ center }) => {
  const map = useMap();

  useEffect(() => {
    const HomeControl = L.Control.extend({
      options: {
        position: 'topleft'
      },
      onAdd: function () {
        const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');

        const button = L.DomUtil.create('a', 'leaflet-control-home', container);
        button.href = '#';
        button.title = 'Return to center';
        button.setAttribute('role', 'button');
        button.setAttribute('aria-label', 'Return to center');

        // Inline SVG home icon
        button.innerHTML = `
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        `;

        // Prevent click from propagating to map
        L.DomEvent.disableClickPropagation(button);
        L.DomEvent.disableScrollPropagation(button);

        // Handle click event
        L.DomEvent.on(button, 'click', function (e: Event) {
          e.preventDefault();
          e.stopPropagation();

          // Pan to center with smooth animation
          map.flyTo(center, map.getZoom(), {
            duration: 1.0
          });
        });

        return container;
      }
    });

    const homeControl = new HomeControl();
    map.addControl(homeControl);

    // Add custom styles
    const style = document.createElement('style');
    style.textContent = `
      .leaflet-control-home {
        background-color: #fff;
        border: none;
        border-radius: 4px;
        box-shadow: none;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #333;
        text-decoration: none;
      }

      .leaflet-control-home:hover {
        background-color: #f4f4f4;
      }

      .leaflet-control-home svg {
        display: block;
      }

      .leaflet-control-custom {
        margin-top: 10px;
      }
    `;
    document.head.appendChild(style);

    return () => {
      map.removeControl(homeControl);
      document.head.removeChild(style);
    };
  }, [map, center]);

  return null;
};

export default HomeButtonControl;
